import { FormikValues } from 'formik'

const genders: FormikValues[] = [
    {
        value: 0,
        label: 'All'
    },
    {
        value: 1,
        label: 'Male'
    },
    {
        value: 2,
        label: 'Female'
    },
    {
        value: 3,
        label: 'Couple'
    }
]

const registrationGenders: FormikValues[] = [
    {
        value: 1,
        label: 'Male'
    },
    {
        value: 2,
        label: 'Female'
    },
    {
        value: 3,
        label: 'Couple'
    }
]

const advGenders: FormikValues[] = [
    {
        value: 0,
        label: 'Not specified'
    },
    {
        value: 1,
        label: 'Male'
    },
    {
        value: 2,
        label: 'Female'
    },
    {
        value: 3,
        label: 'Couple'
    },
    {
        value: 4,
        label: 'Transvestite'
    }
]

const ages: FormikValues[] = [
    {
        value: 0,
        label: 'All'
    },
    {
        value: 1,
        label: '18-24'
    },
    {
        value: 2,
        label: '25-34'
    },
    {
        value: 3,
        label: '35-44'
    },
    {
        value: 4,
        label: '45-54'
    },
    {
        value: 5,
        label: '55-64'
    },
    {
        value: 6,
        label: '64-74'
    },
    {
        value: 7,
        label: '75+'
    }
]

const materials: FormikValues[] = [
    {
        value: 0,
        label: 'Photo and Video'
    },
    {
        value: 1,
        label: 'Photo'
    },
    {
        value: 2,
        label: 'Video'
    }
]

const indexGenders: FormikValues[] = [
    {
        value: 0,
        label: 'All'
    },
    {
        value: 1,
        label: 'Female or couple'
    },
    {
        value: 2,
        label: 'Male'
    }
]

const status: FormikValues[] = [
    {
        value: 0,
        label: 'Free'
    },
    {
        value: 1,
        label: 'Premium'
    }
]

const pages = {
    index: 'index',
    member: 'member',
    profile: 'profile'
}

export { genders, advGenders, ages, materials, indexGenders, pages, status, registrationGenders }
